export const formatNumberToLocale = (number: number, o?: {
	minimumFractionDigits?: number
	maximumFractionDigits?: number
}) => {
	return number.toLocaleString(undefined, o);
}

export const isMultiplesOf = (number: number, value: number) => {
	return value % number === 0;
}